import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import BlitzAPI from '../../api/BlitzAPI';

const cellEditProp = {
  mode: 'dbclick',
  blurToSave: true,
};

function emailDataFormat(cell, row) {
  const args = {
    subject: '[Free $10 RP] Blitz Esports wants to hear from you about the Desktop app!',
    body: `Hi ${row.summoner_name},

My name is Shawn, Lead Designer at Blitz, and I'd like to personally thank you for trying out Blitz Desktop Beta.
We noticed that you have stopped using the app for quite some time, and we'd love to learn why it's not useful to you.

Are you available for a quick 15-minute chat some time this week over Discord or Skype? If so, please sign up for a time slot that works the best for you here: https://calendly.com/blitz-interview-june/15min (You will receive free $10 RP gift card for your time.)

If not, feel free to just reply to share some thoughts!

Best,
Shawn`
  }

  const argsString = Object.entries(args).map(kv => kv.map(encodeURIComponent).join("=")).join("&");

  const mailToData = `mailto:${row.email}?${argsString}`

  return (
    <a href={mailToData}>{cell}</a>
  );
}

export default class UserListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      query: { page_size: 50 },
      username: '',
      search: '',
    };
    this.getData = this.getData.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onSizePerPageList = this.onSizePerPageList.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.handleCheckboxToggle = this.handleCheckboxToggle.bind(this);
  }

  componentDidMount() {
    const { query } = this.state;
    this.getData(query);
  }

  onPageChange(page, sizePerPage) {
    const query = Object.assign({}, this.state.query, { page });
    this.setState({ query }, this.getData);
  }

  onSizePerPageList(sizePerPage) {
    const query = Object.assign({}, this.state.query, { page_size: sizePerPage })
    this.setState({
      query
    }, this.getData)
  }

  onSortChange(sortName, sortOrder) {
    const sorting = sortOrder === 'asc' ? sortName : `-${sortName}`;
    const query = Object.assign({}, this.state.query, { order_by: sorting });
    this.setState({
      query,
    }, this.getData);
  }

  getData() {
    BlitzAPI.getStatsUsers(this.state.query).then(
      (resp) => {
        return this.setState({
          data: resp.data.data,
          sizePerPage: resp.data.page_size,
          dataTotalSize: resp.data.total_entries,
          currentPage: resp.data.page_number,
        });
      },
    );
  }

  onSearchChange(e) {
    this.setState({ search: e.target.value });
    let { query } = this.state;
    if (!e.target.value) {
      delete query.search;
    } else {
      query = Object.assign({}, query, { search: e.target.value });
    }
    this.setState({ query }, this.getData);
  }

  handleCheckboxToggle(event) {
    const target = event.target;
    const value = target.checked;
    const name = target.name;
    let { query } = this.state;
    query = Object.assign({}, query, { [name]: value });

    this.setState({
      [name]: value,
      query
    }, this.getData);
  }

  render() {
    const { data, username, search, sizePerPage, currentPage, dataTotalSize } = this.state;

    return (
      data ?
        <div style={{ marginTop: '20px' }}>
          <div className="clearfix">
            <div style={{ float: 'right' }}>
              <input value={search} onChange={this.onSearchChange} placeholder="Search" />
            </div>
            <div>
            <form>
              <label>
                <span style={{ paddingRight: '10px' }}><strong>Show only dropoff:</strong></span>
                <input
                  name="dropoff"
                  type="checkbox"
                  checked={this.state.dropoff}
                  onChange={this.handleCheckboxToggle} />
              </label>
            </form>
            </div>
          </div>

          <BootstrapTable
            data={this.state.data}
            remote striped hover pagination
            cellEdit={cellEditProp}
            fetchInfo={{ dataTotalSize: dataTotalSize }}
            options={{
              onCellEdit: this.onCellEdit,
              onSortChange: this.onSortChange,
              sizePerPage: sizePerPage,
              onPageChange: this.onPageChange,
              page: currentPage,
              onSizePerPageList: this.onSizePerPageList,
            }}
          >
            <TableHeaderColumn dataField="summoner_name">Summoner Name</TableHeaderColumn>
            <TableHeaderColumn dataField="email" dataFormat={emailDataFormat}>Email</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="region">Region</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="total_ratio">Total Ratio</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="total_matches_tracked">Total Matches Tracked</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="total_matches_played">Total Matches Played</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="last_week_ratio">Last Week Ratio</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="last_week_tracked">Last Week Tracked</TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="last_week_played">Last Week Played</TableHeaderColumn>
            <TableHeaderColumn dataSort isKey dataField="account_id">Account Id</TableHeaderColumn>
          </BootstrapTable>
        </div> : <div><h1>Loading</h1></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/tracking/AppTrackingTable.js